import React, { Component } from 'react';
import { Link } from "react-router-dom";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { slide as Menu } from 'react-burger-menu'
import css from './MobileNav.module.scss';
import ImgMenuIcon from './assets/Hamburger.png';
import ImgCloseIcon from './assets/Close.png';



export default class MobileNav extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})
  }

  closeMenu () {
    this.setState({menuOpen: false})
  }

  toggleMenu () {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  render () {
      return (
        <div className={css.mobileNav}>
          <p className={css.logo}><Link
           to="/"
           onClick={() => this.closeMenu()}>Derek Fidler</Link></p>
          <Menu
          right
          noOverlay
          width={'100%'}
          isOpen={false}
          pageWrapId={ "page-wrap" }
          outerContainerId={ "outer-container" }
          customBurgerIcon={ <img src={ImgMenuIcon} alt="Menu"/> }
          customCloseIcon={ <img src={ImgCloseIcon} alt="Close Menu"/> }
          burgerButtonClassName={ css.openButton }
          crossButtonClassName={ css.closeButton }
          menuClassName={ css.menu }
          itemListClassName={ css.menuList }
          itemClassName={ css.menuItem}
          >
           <li>
             <Link
              to="/"
              onClick={() => this.closeMenu()}>
              Projects</Link>
           </li>
           <li>
             <Link
              to="/about/"
              onClick={() => this.closeMenu()}>
              About</Link>
           </li>
           <li>
             <AnchorLink
              href='#contact'
              onClick={() => this.closeMenu()}>
              Contact</AnchorLink>
           </li>
          </Menu>
        </div>
      )
   }
}
